import { render } from "./Nous.vue?vue&type=template&id=49d10920&scoped=true"
import script from "./Nous.vue?vue&type=script&lang=js"
export * from "./Nous.vue?vue&type=script&lang=js"

import "./Nous.vue?vue&type=style&index=0&id=49d10920&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-49d10920"

export default script